import React from 'react';
import PropTypes from 'prop-types';
import Button from 'react-bootstrap/Button';
import { Link } from 'react-router-dom';
import OrderHeader from 'components/Order/OrderHeader';
import { SimpleDetails, MethodDetails } from './Details';
import { Product } from 'components/Product';
import orderSummary from 'config/orderSummary.json';
import OrderInformation from './OrderInformation'

const OrderDetails = (props) => {
    return (
        props && (
            <div className="order__details">
                <div className="order order--p2" id="order-information">
                    <OrderHeader orderNumber={props.orderNumber} title={`Istotne informacje`} className="" />
                    <OrderInformation props={props} />
                </div>
                <div className="order order--p2" id="order-products">
                    <OrderHeader orderNumber={props.orderNumber} title={`Zamówione produkty`} />
                    <ul className="order__list order__list--products" id="order-products">
                        {props.products &&
                            props.products.map((product, key) => (
                                <Product key={key} orderNumber={props.orderNumber} {...product} />
                            ))}
                    </ul>
                    <div className="order__list--actions">
                        {props.orderStatus === 4 && (
                            <Button
                                as={Link}
                                to={`/review/${props.orderNumber}`}
                                variant="outline-secondary"
                                className="btn__default"
                            >
                                Oceń produkty
                            </Button>
                        )}
                    </div>
                </div>
                <div className="order order--p2" id="order-methods">
                    <OrderHeader orderNumber={props.orderNumber} title={`Dostawa i płatność`} />

                    <ul className="order__list order__list--methods">
                        {props.payment && (
                            <MethodDetails label="Metoda płatności" method="payments" selected={props.payment} />
                        )}
                        {props.delivery && (
                            <MethodDetails label="Metoda dostawy" method="shipping" selected={props.delivery} />
                        )}
                    </ul>
                </div>
                <div className="order order--p2" id="order-summary">
                    <OrderHeader orderNumber={props.orderNumber} title={`Łączna kwota`} />
                    <ul className="order__list mb-0">
                        {orderSummary.map((item, key) => {
                            return props.summary[item.id] && <SimpleDetails key={key} {...item} props={props} isFormatNumber isPostfix />
                        })}
                    </ul>
                </div>
            </div>
        )
    );
};

OrderDetails.propTypes = {
    orderNumber: PropTypes.string.isRequired,
    created: PropTypes.string.isRequired,
    deliveryTime: PropTypes.string.isRequired,
    orderStatus: PropTypes.object.isRequired,
    products: PropTypes.array.isRequired,
};

export default OrderDetails;
